import {
    ReactElement,
    ButtonHTMLAttributes
} from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    title: string;
    value:any;
    myStyle?:string;
    onClick?:any;
}

export function TableRowResponsive({ title,value, myStyle, onClick}: Props): ReactElement {


    return (
        <div className={`table-row-responsive col-4 ${myStyle}`} onClick={onClick}>
            <span className="title">
              {title}
            </span>
            <span className="value">
                {value}
            </span>
        </div>
    )
}

export default TableRowResponsive;